import script from "./UpdateHistorys.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateHistorys.vue?vue&type=script&setup=true&lang=js"

import "./UpdateHistorys.vue?vue&type=style&index=0&id=3af8fce8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3af8fce8"]])

export default __exports__